import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Medallion } from './Medallion';
import { CtaButton } from './CtaButton';
export function GuaranteeSection() {
  return <section className="w-full bg-ivory py-10 sm:py-14" aria-labelledby="guarantee-heading" data-id="element-81" data-mp="9ucpp2an3d0j">
      <div className="mx-auto max-w-3xl px-6" data-id="element-82" data-mp="9wpenzetenn3">
        <div className="rounded-4xl border border-line bg-shell px-7 py-10 text-center shadow-soft sm:px-12" data-id="element-83" data-mp="euh5sr7my5q8">
          <Medallion icon={ShieldCheckIcon} data-id="element-84" data-mp="jrr30t19nlom" />

          <p className="eyebrow mt-6 text-navy" data-id="element-85" data-mp="nu4ablvnvrni">
            🛡️ Your investment is 100% protected
          </p>
          <h2 id="guarantee-heading" className="mx-auto mt-4 max-w-xl font-display text-[1.7rem] font-extrabold leading-[1.12] text-ink sm:text-4xl" data-id="element-86" data-mp="skcb9f79u9z7">
            The Iron-Clad 7-Day Content Guarantee
          </h2>

          <p className="mx-auto mt-6 max-w-readable font-sans text-base leading-relaxed text-stone" data-id="element-87" data-mp="12jti3zy9etwr">
            You receive exactly what this page promises: 6 volumes, 150
            ready-to-teach lessons, 150+ elite drills and all 7 strategic
            bonuses. If what is delivered doesn’t match what we promised, email
            us within 7 days and we refund{' '}
            <span className="font-semibold text-ink" data-id="element-88" data-mp="1vthgefv1pcnd">100% of your money</span>.
            No questions. No hassles.
          </p>

          <p className="mx-auto mt-5 max-w-readable font-sans text-[0.85rem] leading-relaxed text-stone" style={{
          fontSize: "12px"
        }} data-id="element-89" data-mp="1rt7cd8qtcwb5">
            The guarantee covers the content you are buying — not your results
            on court, which depend on how you coach with it.
          </p>

          <div className="mt-9" data-id="element-90" data-mp="2ertv0h4q7eqc">
            <CtaButton variant="navy" data-id="element-91" data-mp="2eqsh84wbse4x">Get the Vault risk-free</CtaButton>
          </div>
        </div>
      </div>
    </section>;
}